import type { SahReadinessCheckKey } from '@statura/utils';
import {
  sahClientConsentsHref,
  sahClientCreateAgreementHref,
  sahCarePlanStartHref,
  sahClientDecisionMakersHref,
  sahClientDeliveryReadinessHref,
  sahClientFundingArrangementHref,
  sahClientHcpOpeningHref,
  sahClientHubHref,
} from '@/lib/sah/sah-href-contract';
import {
  sahBudgetFundingHref,
  sahBudgetFundingSetupHref,
} from '@/lib/sah/unified-sah-action-queue';

/**
 * Deep-link targets for book-wide SAH readiness gate cells. Anchors align with
 * the Journey hub sections and the Budget tab funding surfaces.
 */
export function sahReadinessGateHref(clientId: string, gateKey: SahReadinessCheckKey): string {
  switch (gateKey) {
    case 'classification':
    case 'means_tier':
      return sahBudgetFundingSetupHref(clientId);
    case 'consents':
    case 'care_consent':
      return sahClientConsentsHref(clientId);
    case 'care_plan':
      return sahCarePlanStartHref(clientId);
    case 'signatory':
      return sahClientDecisionMakersHref(clientId);
    case 'service_agreement':
      return sahClientCreateAgreementHref(clientId);
    case 'head_provider':
      return sahClientFundingArrangementHref(clientId);
    case 'budget':
      return sahBudgetFundingHref(clientId);
    case 'hcp_opening':
      return sahClientHcpOpeningHref(clientId);
    default:
      return sahClientHubHref(clientId);
  }
}

/** Canonical delivery-readiness deep link for book/schedules launchpad CTAs. */
export function sahDeliveryReadinessHref(clientId: string): string {
  return sahClientDeliveryReadinessHref(clientId);
}
